import * as React from "react"
import { Col, Row } from "react-grid-system"
import { useTranslation } from "react-i18next"
import { theme } from "../../theme"
import CardBar from "../../atoms/CardBar"
import H3 from "../../atoms/typography/H3"
import TextButton from "../../atoms/buttons/TextButton"
import { SortingArrowsIcon } from "../../atoms/icons/SortingArrows"

interface Props {
  onSortTerminalName?: () => void
  onSortSerialNumber?: () => void
  onSortSuborg?: () => void
  onSortDataUsage?: () => void
  onSortGroup?: () => void
  onSortStatus?: () => void
}

const TerminalsOverviewActionBar: React.FunctionComponent<Props> = ({
  onSortDataUsage,
  onSortSerialNumber,
  onSortSuborg,
  onSortTerminalName,
  onSortGroup,
  onSortStatus,
}) => {
  const { t } = useTranslation()

  return (
    <CardBar open={true}>
      <Row justify="center" align="center">
        <Col md={2}>
          <TextButton
            title="Name"
            color={theme.colors.white}
            icon={<SortingArrowsIcon />}
            onClick={onSortTerminalName}
          />
        </Col>
        <Col md={2}>
          <TextButton
            title="Serial Number"
            color={theme.colors.white}
            icon={<SortingArrowsIcon />}
            onClick={onSortSerialNumber}
          />
        </Col>
        <Col md={2}>
          <TextButton
            title="Org / Suborg"
            color={theme.colors.white}
            icon={<SortingArrowsIcon />}
            onClick={onSortSuborg}
          />
        </Col>
        <Col md={2}>
          <H3 color={theme.colors.white}>{t("groups")}</H3>
        </Col>
        <Col md={2}>
          <H3 color={theme.colors.white}>{t("status")}</H3>
        </Col>
        <Col md={2}>
          <TextButton
            title="Data usage"
            color={theme.colors.white}
            icon={<SortingArrowsIcon />}
            onClick={onSortDataUsage}
          />
        </Col>
      </Row>
    </CardBar>
  )
}

export default TerminalsOverviewActionBar
